import React, { useState, useEffect } from 'react';
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faUpload, faMoneyBillWave, faCheckCircle, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { collection, doc, Timestamp, setDoc,  serverTimestamp, getFirestore } from "firebase/firestore";
import { getDocs, query, where } from "firebase/firestore"; 
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getStorage, uploadBytesResumable } from "firebase/storage";
import { app } from "../firebase"; 
import swal from 'sweetalert'; 
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { getAuth, onAuthStateChanged } from "firebase/auth"; 
import { Link, useNavigate } from 'react-router-dom';



function SenderID() {


  const [senderId, setSenderId] = useState('');
  const [email, setEmail] = useState('');
  const [safaricomNumber, setSafaricomNumber] = useState('');
  const storage = getStorage();
  const db = getFirestore();
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [userId, setUserId] = useState("");
  const [userName, setUserName] =  useState();
  const [myTotalSMS, setMyTotalSMS] = useState();
  const [status, setStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
  const [loggedInPhone, setLoggedInPhone] = useState();
  const [issuedSMS, setissuedSMS] = useState();
  const [purchasedSMS, setPurchasedSMS] = useState();
  const [myissuedSMS, setMyissuedSMS] = useState();
  const [error, setError] = useState(''); 

  const [senderIdAmount, setsenderIdAmount] = useState();
  const [defaultSenderId, setdefaultSenderId] = useState();
  const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth(app);
        onAuthStateChanged(auth, (user) => {
        if (user) {
            const uid = user.uid;
            setUserId(user.uid);
            fetchUserStatus(uid);
            checkSenderIDApplication(uid);
            fetchGlobalSettings();
        }
        });
    }, []);

      const fetchUserStatus = async (uid) => {
        const userQuery = query(collection(db, "users"), where("userId", "==", uid));
        const querySnapshot = await getDocs(userQuery);
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          setStatus(data.status || "Unsubscribed");
          setUserName(data.businessName);
          setLoggedInPhone(data.phone);
          setPurchasedSMS(data.purchasedSMS);
          setMyissuedSMS(data.issuedSMS);
    
          const theissuedSMS = parseInt(data.issuedSMS);
          const myPurchasedSMS = data.purchasedSMS; 
    
          const totalSMS = theissuedSMS + myPurchasedSMS;
          setMyTotalSMS(totalSMS);
    
          // Subscription check
          const subscriptionEnd = data.subscriptionEnd?.toDate?.();
          if (subscriptionEnd) {
            const now = new Date();
            const isExpired = now > subscriptionEnd;
            setSubscriptionStatus(isExpired ? "Expired" : "Active");
          } else {
            setSubscriptionStatus("Unsubscribed");
          }
    
          
        });
      };
    
      const fetchGlobalSettings = async() => {
        const userQuery = query(collection(db, "globalSettings"), where("docID", "==", "wqSDO1OEBintZqf0svF6"));
        const querySnapshot = await getDocs(userQuery);
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();

          setsenderIdAmount(data.senderIdAmount);
          setdefaultSenderId(data.defaultSenderId);

          
        });
      };



  const [files, setFiles] = useState({
    safaricom: null,
    airtel: null,
    telkom: null
  });

  const handleFileUpload = (provider, file) => {
    setFiles(prev => ({
      ...prev,
      [provider]: file
    }));
    alert(`${provider} authorization letter uploaded`);
  };

  const canSubmit = senderId && email && safaricomNumber && Object.values(files).some(f => f);


    function processPayment(){

        if (!safaricomNumber || !safaricomNumber.match(/^(\+254|254|0)?(1|7)\d{8}$/)) {
            swal('Error', "Enter a valid Safaricom number.", 'error');
            // setIsLoading(false);
            return;
        }

        if (!canSubmit) {
            swal("Incomplete Details", "Please fill in all fields and upload at least one document.", "warning");
            return;
        }

        setIsSubmitting(true);

        const formattedPhone = formatPhoneNumber(safaricomNumber);
            try {
                    const displayAmount = senderIdAmount;
                
                    // Your Firebase Function URL
                    const baseUrl = 'https://us-central1-kuzapoints.cloudfunctions.net/paymentApi';

                    const paymentDesc = "Initial Setup";

                    makePayment(displayAmount, formattedPhone, userName, paymentDesc)

                    // Function to make a payment using fetch
                    async function makePayment(amount, contactPhoneNumber, contactName, description) {
                    try {
                        const payload = {
                        amount,
                        contact_phone_number: contactPhoneNumber,
                        contact_name: contactName,
                        description,
                        };

                        const response = await fetch(`${baseUrl}/make-payment`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                        });

                        if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.error || 'Payment request failed');
                        }

                        const data = await response.json();
                        // Access the transaction ID
                        //console.log(data)
                        const transactionId = data?.data?.data?.transaction?.id;

                        //console.log('🧾 Transaction ID:', transactionId);


                        // Show SweetAlert with two buttons
                            swal({
                            title: 'Payment Initiated',
                            text: 'Have you completed the payment on your phone?',
                            icon: 'info',
                            buttons: {
                                cancel: {
                                text: "No, I haven't paid",
                                visible: true,
                                closeModal: true,
                                },
                                confirm: {
                                text: 'Yes, I have paid',
                                closeModal: true,
                                },
                            },
                            }).then((confirmed) => {
                            if (confirmed) {
                                //console.log('✅ User confirmed they paid');
                                // Optionally call verifyPayment(transactionId) here
                                verifyPayment(transactionId) 
                            } else {

                                console.log('⏳ User has not completed the payment yet');
                            }
                            });
                        return transactionId;
                    } catch (error) {
                        console.error('❌ Error making payment:', error.message);
                    }
                    }


                    //verify payments

                    // Function to verify payment
                    async function verifyPayment(transactionId) {
                    try {
                        const response = await fetch(`${baseUrl}/verify-payment/${transactionId}`);
                        if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.error || 'Verification failed');
                        }

                        const data = await response.json();
                        const transaction = data?.data?.data?.transaction?.[0];

                        //console.log('✅ Payment Verified:', transaction);

                        if (transaction.status === "success") {
                        // swal('Payment Verified!', 'Your payment has been successfully processed.', 'success');

                            const payMethod = "Mpesa";
                            const currency = "KES";
                            const responseReference = transactionId;
                            const responseTrans = "success"; 

                            uploadDataToFirestore(payMethod, currency,responseReference, responseTrans , displayAmount );
                            toast.success(`Payment was successful, please wait....`);

                        } else {
                        //swal('Payment Still Pending', `Status: ${transaction.status}`, 'info');
                        //window.location.reload();
                        swal({
                            title: 'Payment Still Pending',
                            text: transaction.status,
                            icon: 'info',
                            buttons: {
                            cancel: 'Cancel',
                            retry: {
                                text: 'Try Again',
                                value: 'retry',
                            },
                            },
                        }).then((value) => {
                            if (value === 'retry') {
                                const payMethod = "Mpesa Web Payments";
                                const currency = "KES";
                                const responseReference = transactionId;
                                const responseTrans = "success"; 

                                uploadDataToFirestore(payMethod, currency,responseReference, responseTrans , displayAmount );
                                toast.success(`Payment was successful, please wait....`);
                            }
                        });
                        
                        }
                    } catch (error) {
                        console.error('❌ Verification Error:', error.message);
                        swal('Verification Failed', error.message, 'error');
                        setIsSubmitting(false);
                    }
                }




            } catch (err) {
                console.error(err);
                alert("Failed to initiate payment. Try again.");
                setIsSubmitting(false);
        } finally {
        
    }

    }

    const uploadDataToFirestore = async (payMethod, currency,transactionId, responseTrans , displayAmount) => {
    setIsSubmitting(true);
    setUploadProgress(0);

    try {
        const fileUrls = {};
        const totalFiles = Object.values(files).filter(f => f).length;
        let uploaded = 0;

        for (const [provider, file] of Object.entries(files)) {
        if (file) {
            const storageRef = ref(storage, `senderID/${provider}/${Date.now()}_${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            await new Promise((resolve, reject) => {
            uploadTask.on(
                'state_changed',
                (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(Math.round(((uploaded + progress / 100) / totalFiles) * 100));
                },
                (error) => reject(error),
                async () => {
                const url = await getDownloadURL(uploadTask.snapshot.ref);
                fileUrls[provider] = url;
                uploaded++;
                setUploadProgress(Math.round((uploaded / totalFiles) * 100));
                resolve();
                }
            );
            });
        }
        }

         const newDataRef = doc(collection(db, "senderIDRequests"));
         await setDoc(newDataRef, {
            senderId,
            email,
            safaricomNumber,
            uploadedFiles: fileUrls,
            status: "Pending",
            paymentStatus: "Success",
            transactionId,
            timeCreated: serverTimestamp(),
            docId:newDataRef.id,
            userId:userId 

        }).then(()=>{
            const newDataRef = doc(collection(db, "Income"));
            setDoc(newDataRef, {
    
                loggedInUser: userId,
                paymentDate: serverTimestamp(),
                paymentMethod: payMethod,
                userId: userId,
                currency,
                responseReference: transactionId, 
                responseTrans, 
                displayAmount,
                paymentFor:"Sender ID",
                docId:newDataRef.id
                }).then(()=>{

                    const phoneNumber = loggedInPhone; 
                    const message = `Hello ${userName}, we've received your Sender ID registration request. The process takes up to 14 working days. We will notify you once it's approved. Thank you!`
                    sendSms(message, phoneNumber);


                })
    });

        
    } catch (error) {
        console.error("Submission error:", error);
        swal("Error", "Something went wrong during file upload.", "error");
    } finally {
        setIsSubmitting(false);
    }
    };


    function buyMoreCredits(){
        navigate("/settings")
    }
 

  //format the phone number 
  const formatPhoneNumber = (number) => {
    // Strip non-numeric characters
    let cleaned = number.replace(/[^0-9]/g, '');

    // Handle various cases
    if (cleaned.startsWith('0')) {
      cleaned = '254' + cleaned.slice(1); // Replace leading 0 with 254
    } else if (cleaned.startsWith('254')) {
      // No change needed
    } else if (cleaned.startsWith('7')) {
      cleaned = '254' + cleaned; // Add 254 if starts with 7
    } else if (cleaned.startsWith('+254')) {
      cleaned = cleaned.slice(1); // Remove the + sign
    } else if (cleaned.startsWith('1')) {
      cleaned = '254' + cleaned; // For landlines or similar cases starting with 1
    }

    // Ensure the number has 12 digits
    if (cleaned.length === 12 && cleaned.startsWith('254')) {
      return cleaned;
    } else {
      setError('Please enter a valid phone number in the format 254XXXXXXXXX');
      return null;
    }
  };

  const [registrationDoc, setRegistrationDoc] = useState(null);
  const [registrationDocName, setRegistrationDocName] = useState("");

  const handleRegistrationDocChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        setRegistrationDoc(file);
        setRegistrationDocName(file.name);

        // Also add to files for uniform upload logic
        setFiles((prev) => ({ ...prev, registration: file }));
    }
    };


    const sendSms = async (message, phoneNumber) => {
          const auth = getAuth();
          const user = auth.currentUser;
      
          if (!user) {
              console.error("User not logged in");
              return;
          }
      
          try {
              const token = await user.getIdToken();
      
              const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ message, phoneNumber }),
              });
      
              const data = await response.json();
      
              if (response.ok) {
                  swal("Submitted Successfully", "We have received your Sender ID registration request. The process takes up to 14 working days. We will notify you once it's approved!", "success").then(()=>{
                        navigate("/settings")
                    })
                  return true;
              } else {
                    swal("Submitted Successfully", "We have received your Sender ID registration request. The process takes up to 14 working days. We will notify you once it's approved!", "success").then(()=>{
                        navigate("/settings")
                    })
                  return true;
              }
          } catch (err) {
                  swal("Submitted Successfully", "We have received your Sender ID registration request. The process takes up to 14 working days. We will notify you once it's approved!", "success").then(()=>{
                      navigate("/settings")
                  })
                return true;
          }
    };



  const providers = [
    { name: 'safaricom', label: 'Safaricom', color: 'text-success' },
    { name: 'airtel', label: 'Airtel', color: 'text-danger' },
    { name: 'telkom', label: 'Telkom', color: 'text-primary' }
  ];


    const [checking, setChecking] = useState(true);
    const [senderIDCreatedTime, setSenderIDCreatedTime] = useState(null);
    const [hasAppliedSenderID, setHasAppliedSenderID] = useState(false);

    const checkSenderIDApplication = async (uid) => {
      try {
        const q = query(
          collection(db, "senderIDRequests"),
          where("userId", "==", uid) // Ensure the field name is correct in your Firestore documents
        );
        const snapshot = await getDocs(q);
        const docData = snapshot.docs[0].data();
        setSenderIDCreatedTime(docData.timeCreated);
  
        setHasAppliedSenderID(!snapshot.empty);
        console.log(!snapshot.empty)

        if (!snapshot.empty){
          console.log(!snapshot.empty)
        }
      } catch (error) {
        //navigate("/settings");
        //console.error("Error checking sender ID application:", error);
      
      } finally {
        setChecking(false);
      }
    };


  return (
    <div className="dashBCont">
      <LeftBar />
      <div className="dashBcontA">
        <NavBarAccount />
        <div className="DashContent container py-4">
          <h2 className="mb-4 myPrimaryColor">
            <i className="fas fa-cogs me-2 myPrimaryColor" />Sender ID Registration
          </h2>

          <div className="row">
            {/* Sender ID Setup */}
            <div className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header">
                  <i className="fas fa-paper-plane me-2" /> Sender ID Configuration
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label htmlFor="senderId" className="form-label">Unique Sender ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="senderId"
                      maxLength={11}
                      placeholder="e.g., BUNI SCHOOL"
                      value={senderId}
                      onChange={(e) => setSenderId(e.target.value)}
                    />
                    <div className="d-flex justify-content-between">
                        <small className="text-muted">Max 11 characters. This appears as the sender name in SMS.</small>
                        <small className={`text-${senderId.length > 10 ? 'danger' : 'secondary'}`}>
                        {senderId.length}/11
                        </small>
                    </div> 
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="fas fa-envelope" /></span>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="your-email@company.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <small className="text-muted">Used for registration notifications.</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Current Settings */}
            <div className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header">
                  <i className="fas fa-info-circle me-2" />Current Settings
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <p className="mb-1 fw-bold">Active Sender ID</p>
                    <p className="text-success fs-5">{defaultSenderId}</p>
                  </div>
                  <div className="mb-3">
                    <p className="mb-1 fw-bold">SMS Balance</p>
                    <p className="text-primary fs-5">{myTotalSMS} SMS</p>
                  </div>
                  <button className="btn myPrimaryBtn w-100" onClick={buyMoreCredits}>Buy More SMS Credits</button>
                </div>
              </div>
            </div>
          </div>

          {/* File Upload Section */}
          <div className="card mb-4">
            <div className="card-header">
              <i className="fas fa-file-upload me-2" /> Authorization Letters
            </div>
            <div className="card-body">
              <div className="row">
                {providers.map(provider => (
                  <div key={provider.name} className="col-md-4 mb-4">
                    <div className="text-center mb-2">
                      <strong className={provider.color}>{provider.label}</strong>
                      <p className="text-muted small">Authorization Letter</p>
                    </div>
                    <div className="border border-secondary rounded p-3 text-center">
                      <input
                        type="file"
                        id={`${provider.name}-file`}
                        className="d-none"
                        accept=".pdf,.doc,.docx,.jpg,.png"
                        onChange={(e) => handleFileUpload(provider.name, e.target.files[0])}
                      />
                      <label htmlFor={`${provider.name}-file`} className="cursor-pointer d-block">
                        <i className="fas fa-upload fa-2x text-secondary mb-2" />
                        <p className="small text-muted">
                          {files[provider.name]?.name || 'Click to upload'}
                        </p>
                      </label>
                      {files[provider.name] && (
                        <div className="text-success small mt-2">
                          <i className="fas fa-check-circle me-1" />
                          File uploaded successfully
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="alert alert-info mt-4">
                <h6 className="fw-bold">Authorization Letter Requirements:</h6>
                <ul className="mb-0 small">
                  <li>Must be on company letterhead</li>
                  <li>Should authorize the use of your sender ID</li>
                  <li>Signed by an authorized company rep</li>
                  <li>Formats allowed: PDF, DOC, DOCX, JPG, PNG</li>
                  <li><Link to='/sender-id-templates'>View Sample templates here</Link></li>
                </ul>
              </div>
            </div>
        </div>

        {/*  */}

        <div className="card mb-5">
        <div className="card-header">
            <i className="fas fa-money-bill-wave me-2" /> Company / Business Registration Document
        </div>
        <div className="card-body">
            <div className="mb-3">
            <label
                htmlFor="registrationDoc"
                className="d-flex flex-column align-items-center justify-content-center p-4 border border-dashed border-2 rounded text-center cursor-pointer bg-light"
                style={{ borderColor: "#ced4da", transition: "border-color 0.3s" }}
            >
                <i className="fas fa-cloud-upload-alt fa-2x mb-2 text-primary" />
                <strong className="text-dark">Click to upload</strong>
                <small className="text-muted">PDF, JPG or PNG allowed</small>

            </label>
            <input
                type="file"
                id="registrationDoc"
                accept=".pdf,.jpg,.png"
                className="d-none"
                onChange={handleRegistrationDocChange}

            />
            <p id="registrationDocStatus" className="text-sm text-muted">
            {registrationDocName || "Upload your company/business registration document"}
            </p>
            </div>
        </div>
        </div>




        {/* Payment Section */}
        <div className="card mb-5">
        <div className="card-header">
            <i className="fas fa-money-bill-wave me-2" /> Payment Information
        </div>
        <div className="card-body">
            <div className='alert alert-primary'>
                You will be required to pay a one time fee of <strong>KES {senderIdAmount}</strong> for your Safaricom, Airtel and Telkom Sender ID plus setup.
            </div>
            <div className="mb-3">
            <label htmlFor="safaricomNumber" className="form-label">Your Safaricom Number</label>
            <div className="input-group">
                <span className="input-group-text"><FontAwesomeIcon icon={faPhone} /></span>
                <input
                type="tel"
                className="form-control"
                id="safaricomNumber"
                placeholder="e.g., 07XXXXXXXX"
                value={safaricomNumber}
                onChange={(e) => setSafaricomNumber(e.target.value)}
                />
            </div>
            </div>


            {isSubmitting ? (
            <div className="text-center">
                <div className="spinner-border text-success mb-2" role="status" />
                <p className="text-muted">Uploading documents... {uploadProgress}%</p>
                <div className="progress">
                <div
                    className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                    role="progressbar"
                    style={{ width: `${uploadProgress}%` }}
                    aria-valuenow={uploadProgress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                ></div>
                </div>
            </div>
            ) : (
            <button
                className="btn btn-success w-100"
                onClick={processPayment}
            >
                Submit and Pay KES {senderIdAmount} via M-Pesa
            </button>
            )}

        </div>
        </div>

        </div>
      </div>

    <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}  
        />

    </div>
  );
}

export default SenderID;